import { ApiError } from "@/lib/api/client";
import { Button } from "@/components/ui/button";

// OptimisticLockBanner shows when the server returns 409 STALE_WRITE on an
// update. The user picks: refresh (reload the freshest row and lose their
// edits) or retry (re-send with a new expected_updated_at — caller wires
// this via the `onForce` callback to bypass the stale check).

export interface OptimisticLockBannerProps {
  error: unknown;
  onRefresh: () => void;
  onForce?: () => void;
}

export function OptimisticLockBanner({
  error,
  onRefresh,
  onForce,
}: OptimisticLockBannerProps) {
  if (!(error instanceof ApiError) || !error.isStale) return null;
  return (
    <div className="rounded-md border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm">
      <p className="font-medium text-amber-900 dark:text-amber-100">
        Someone else updated this row while you were editing.
      </p>
      <p className="mt-1 text-amber-800/80 dark:text-amber-100/80">
        Refresh to pull the latest version; your unsaved edits will be lost.
      </p>
      <div className="mt-2 flex gap-2">
        <Button size="sm" variant="default" onClick={onRefresh}>
          Refresh
        </Button>
        {onForce && (
          <Button size="sm" variant="ghost" onClick={onForce}>
            Force save anyway
          </Button>
        )}
      </div>
    </div>
  );
}
